namespace RioERP.Masters {
    export interface LevelsRow {
        Id?: number;
        Name?: string;
        CourseId?: number;
        SortOrder?: number;
        IsActive?: boolean;
        CourseName?: string;
        CourseIsActive?: boolean;
        CourseInsertUserId?: number;
        CourseInsertDate?: string;
        CourseUpdateUserId?: number;
        CourseUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace LevelsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.Levels';
        export const lookupKey = 'Masters.Levels';

        export function getLookup(): Q.Lookup<LevelsRow> {
            return Q.getLookup<LevelsRow>('Masters.Levels');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            CourseId = "CourseId",
            SortOrder = "SortOrder",
            IsActive = "IsActive",
            CourseName = "CourseName",
            CourseIsActive = "CourseIsActive",
            CourseInsertUserId = "CourseInsertUserId",
            CourseInsertDate = "CourseInsertDate",
            CourseUpdateUserId = "CourseUpdateUserId",
            CourseUpdateDate = "CourseUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
